
import ehs from '@/http/requests/ehs'

export default {
  fetchEhsList ({ commit }, data) {
    return new Promise((resolve, reject) => {
      ehs.list(data)
        .then(response => {
          if (data.page > 1) {
            commit('UPDATE_EHS_LIST', response.data.data)
          } else {
            commit('SET_EHS_LIST', response.data.data)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateEhs ({ commit }, data) {
    return new Promise((resolve, reject) => {
      ehs.update(data)
        .then(response => {
          commit('UPDATE_EHS', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateEhsExpiration ({ commit }, data) {
    return new Promise((resolve, reject) => {
      ehs.updateExpiration(data)
        .then(response => {
          commit('UPDATE_EHS', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteEhs ({ commit }, id) {
    return new Promise((resolve, reject) => {
     ehs.delete(id)
        .then(response => {
          commit('DELETE_EHS', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addEhs ({ commit }, data) {
    return new Promise((resolve, reject) => {
      ehs.store(data)
        .then(response => {
          commit('ADD_EHS', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  clearEhsList({ commit }){
    commit('CLEAR_EHS_LIST')
  }
}
